module.exports = __webpack_public_path__ + "img/notify_check.921b8594.svg";